// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_page__F7-yT {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--dylo-login-bg);
  padding: 32px 20px;
  gap: 18px;
}

.Login_card__JV2Ec {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  max-width: 960px;
  min-height: 540px;
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
  overflow: hidden;
  animation: Login_dylo-fade-up__aDEhr 0.4s ease both;
}

/* Panel izquierdo: foto */
.Login_cover__1PT6F {
  position: relative;
  background: #0b1a2b;
}
.Login_coverImg__deowS {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Panel derecho: formulario */
.Login_panel__BRNOB {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 56px;
}

.Login_logoWrap__L5g1l {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.Login_logo__cGlFR {
  height: 56px;
  width: auto;
}

.Login_heading__qhtBv {
  text-align: center;
  margin-bottom: 28px;
}
.Login_title__Tbtha {
  font-size: 34px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
  letter-spacing: -0.5px;
}
.Login_subtitle__OE2HY {
  font-size: 15px;
  color: var(--dylo-muted);
  margin: 4px 0 0;
}

.Login_form__IW16E {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Login_error__7oNLN {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--dylo-danger-bg);
  color: var(--dylo-danger);
  font-size: 13.5px;
  border-radius: var(--radius-sm);
  padding: 10px 12px;
}

.Login_submit__pSMvW {
  margin-top: 6px;
  height: 46px;
  font-size: 15.5px;
}

.Login_suffix__u8akc {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--dylo-field-icon);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  flex-shrink: 0;
}
.Login_suffix__u8akc:hover {
  color: var(--dylo-text);
}

.Login_footer__F3ucv {
  color: rgba(255, 255, 255, 0.55);
  font-size: 12.5px;
  text-align: center;
}

/* Responsive: en pantallas chicas se oculta la foto */
@media (max-width: 760px) {
  .Login_card__JV2Ec {
    /* 🔄 26-oct-2026: \`minmax(0, 1fr)\` y no \`1fr\` (*"en mi telefono no lo veo bien todavia"*, con captura del iPhone).
       Una columna \`1fr\` no baja del ancho mínimo de su contenido, y el de un \`<input>\` sale de su atributo \`size\`
       (20 caracteres): en el iPhone esos campos miden ~35 px más que en Chromium, la columna crecía más que la tarjeta,
       el \`overflow: hidden\` de la tarjeta la recortaba y todo quedaba corrido a la derecha (el título centrado en la
       columna, no en la tarjeta) con los campos y el botón cortados en la orilla. En un teléfono de 375 px pasaba en
       cualquier navegador. En escritorio no cambia: la regla de dos columnas de arriba es otra. */
    grid-template-columns: minmax(0, 1fr);
    max-width: 440px;
    min-height: 0;
  }
  .Login_cover__1PT6F {
    display: none;
  }
  .Login_panel__BRNOB {
    padding: 40px 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4CAA4C;EAC5C,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,mDAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE;IACE;;;;;kGAK8F;IAC9F,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: var(--dylo-login-bg);\n  padding: 32px 20px;\n  gap: 18px;\n}\n\n.card {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  max-width: 960px;\n  min-height: 540px;\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: var(--radius-card);\n  box-shadow: var(--shadow-card);\n  overflow: hidden;\n  animation: dylo-fade-up 0.4s ease both;\n}\n\n/* Panel izquierdo: foto */\n.cover {\n  position: relative;\n  background: #0b1a2b;\n}\n.coverImg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Panel derecho: formulario */\n.panel {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 48px 56px;\n}\n\n.logoWrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n}\n.logo {\n  height: 56px;\n  width: auto;\n}\n\n.heading {\n  text-align: center;\n  margin-bottom: 28px;\n}\n.title {\n  font-size: 34px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n  letter-spacing: -0.5px;\n}\n.subtitle {\n  font-size: 15px;\n  color: var(--dylo-muted);\n  margin: 4px 0 0;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--dylo-danger-bg);\n  color: var(--dylo-danger);\n  font-size: 13.5px;\n  border-radius: var(--radius-sm);\n  padding: 10px 12px;\n}\n\n.submit {\n  margin-top: 6px;\n  height: 46px;\n  font-size: 15.5px;\n}\n\n.suffix {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--dylo-field-icon);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n.suffix:hover {\n  color: var(--dylo-text);\n}\n\n.footer {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 12.5px;\n  text-align: center;\n}\n\n/* Responsive: en pantallas chicas se oculta la foto */\n@media (max-width: 760px) {\n  .card {\n    /* 🔄 26-oct-2026: `minmax(0, 1fr)` y no `1fr` (*\"en mi telefono no lo veo bien todavia\"*, con captura del iPhone).\n       Una columna `1fr` no baja del ancho mínimo de su contenido, y el de un `<input>` sale de su atributo `size`\n       (20 caracteres): en el iPhone esos campos miden ~35 px más que en Chromium, la columna crecía más que la tarjeta,\n       el `overflow: hidden` de la tarjeta la recortaba y todo quedaba corrido a la derecha (el título centrado en la\n       columna, no en la tarjeta) con los campos y el botón cortados en la orilla. En un teléfono de 375 px pasaba en\n       cualquier navegador. En escritorio no cambia: la regla de dos columnas de arriba es otra. */\n    grid-template-columns: minmax(0, 1fr);\n    max-width: 440px;\n    min-height: 0;\n  }\n  .cover {\n    display: none;\n  }\n  .panel {\n    padding: 40px 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Login_page__F7-yT`,
	"card": `Login_card__JV2Ec`,
	"dylo-fade-up": `Login_dylo-fade-up__aDEhr`,
	"cover": `Login_cover__1PT6F`,
	"coverImg": `Login_coverImg__deowS`,
	"panel": `Login_panel__BRNOB`,
	"logoWrap": `Login_logoWrap__L5g1l`,
	"logo": `Login_logo__cGlFR`,
	"heading": `Login_heading__qhtBv`,
	"title": `Login_title__Tbtha`,
	"subtitle": `Login_subtitle__OE2HY`,
	"form": `Login_form__IW16E`,
	"error": `Login_error__7oNLN`,
	"submit": `Login_submit__pSMvW`,
	"suffix": `Login_suffix__u8akc`,
	"footer": `Login_footer__F3ucv`
};
export default ___CSS_LOADER_EXPORT___;
